import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-asbsbtphysicalscience',
    templateUrl: './asbsbtphysicalscience.component.html',
    styleUrls: ['./asbsbtphysicalscience.component.scss']
})
export class AsbsbtphysicalscienceComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
